<template>
  <div class="stepsdemo-content">
    <Card v-if="!loading">
      <template v-slot:title>
        <div class="grid"> 
          <p class="m-0 col-12 text-center">Rappresentante</p>
          <TutorialDialog :slides="slides" :window-size="windowSize" />
        </div>
      </template>
      <template v-slot:subtitle>
        <p>Inserisci i dati del Rappresentante</p>
      </template> 
      <template v-slot:content>
        <div class="box-option">
          <div class="w-full" v-if="rappresentante.exist === null">
            <div class="flex justify-content-center">
              <div class="flex flex-wrap gap-3">
                <div v-for="forma in forme_giuridiche" :key="forma.key" class="flex align-items-center m-2">
                  <RadioButton v-model="selectedFormaGiuridicaName" :inputId="forma.key" :value="forma.value" @change="updateSelectedFormaGiuridica()"/>
                  <label :for="forma.key" class="ml-2">{{ forma.value }}</label>
                </div>
              </div>
            </div>
            <div class="flex justify-content-center ">
              <div class="p-5 col-12 xl:col-6">
                <label class="pb-2" for="codfis">Codice Fiscale/Partita iva <span class="p-error">(obbligatorio)</span></label><br>
                <InputMask v-if="selectedFormaGiuridica.key == 0" mask="aaaaaa99a99a9**a" @complete="inputCF()" v-model="cf" class="text_toupper inputfield w-full"/>
                <InputMask v-if="selectedFormaGiuridica.key == 1" mask="99999999999" @complete="inputCF()" v-model="cf" class="text_toupper inputfield w-full"/>
              </div>
            </div>
          </div>
          <div class="w-full flex flex-wrap" v-else>
            <div v-if="rappresentante.can_view" class="col-12 flex flex-wrap w-full">  
              <div v-if="rappresentante.exist" class="col-12 w-full">
                <div class="flex flex-column justify-content-center box-selected p-2">
                  <Button icon="pi pi-trash" class="btn-remove-selected p-button-rounded p-button-text p-button-danger p-button-sm" aria-label="Rimuovi selezionato" v-tooltip="'Rimuovi selezionato'" @click="initRappresentante(true)"/>
                  <h4 class="selected-name">
                    <a v-if="rappresentanteDetailUrl" class="btn-detail-name" :href="rappresentanteDetailUrl" target="_blank" rel="noopener noreferrer" v-tooltip="'Apri dettaglio rappresentante'">{{rappresentante.name.toUpperCase()}}</a>
                    <span v-else>{{rappresentante.name.toUpperCase()}}</span>
                  </h4>
                  <p class="m-0 col-12 flex flex-column align-items-center">
                    <span class="w-full flex justify-content-center align-items-center">Codice Fiscale: <strong class="m-1"> {{ rappresentante.codfis }}</strong></span>
                  </p>
                  <p v-if="rappresentante.pec" class="m-0 col-12 flex flex-column align-items-center">
                    <span class="w-full flex justify-content-center align-items-center">Pec: <strong class="m-1"> {{ rappresentante.pec }}</strong></span>
                  </p>
                </div>
              </div>
              <div v-else class="w-full flex flex-wrap">
                <div class="flex justify-content-center col-12">
                  <Button class="p-button-rounded card-primary col-3 btn-reset" @click="initRappresentante(true)" icon="pi pi-arrow-up" label="Ritorna alla ricerca"/>
                </div>
                <div class="p-field col-12 flex flex-column align-items-center">
                  <label for="codfis">Codice Fiscale <span class="p-error">(obbligatorio)</span></label><br>
                  <InputMask  v-if="selectedFormaGiuridica.key == 0" disabled class="inputfield col-6 text_toupper" mask="aaaaaa99a99a9**a" v-model="rappresentante.codfis" @input="(val) => (rappresentante.codfis = rappresentante.codfis.toUpperCase())"/>
                  <InputMask  v-if="selectedFormaGiuridica.key == 1" disabled class="inputfield col-6 text_toupper" mask="99999999999" v-model="rappresentante.codfis" @input="(val) => (rappresentante.codfis = rappresentante.codfis.toUpperCase())"/>

                </div>
                <div class="p-field col-12 xl:col-6">
                  <label for="nome">Nome <span class="p-error">(obbligatorio)</span></label><br>
                  <InputText @change="onSelected($event)" v-model="rappresentante.nome" class="inputfield w-full" @input="(val) => (rappresentante.nome = rappresentante.nome.toUpperCase())"/>
                </div>
                <div class="p-field col-12 xl:col-6">
                  <label for="cognome">Cognome <span class="p-error">(obbligatorio)</span></label><br>
                  <InputText @change="onSelected($event)" v-model="rappresentante.cognome" class="inputfield w-full" @input="(val) => (rappresentante.cognome = rappresentante.cognome.toUpperCase())"/>
                </div>
              </div>
              <div v-if="canUseClientAddress && !rappresentante.exist && (newContatto || sameAddress)" class="p-field col-12 xl:col-6 flex justify-content-between mt-3">
                <label><strong>L'indirizzo di spedizione coincide con l'indirizzo della sede legale</strong></label>
                <Checkbox v-model="sameAddress" :binary="true" @change="setSameAddress"/>
              </div>
              <div v-if="contatti.length" class="w-full flex flex-wrap">
                <label class="m-2 col-12 flex justify-content-center">
                  <strong>Contatto</strong>
                </label>
  
                <div class="w-full grid justify-content-start">
                  <Button v-for="contatto in contatti" :key="contatto.same_to_client ? 'same_to_client' : contatto.id" :class="`card-primary flex flex-column align-items-start btn-contatto btn-selection ${(repairSourceContactId ? contatto.id == repairSourceContactId : contatto.selected) ? 'selected' : ''} ${(contatto.invalid_fields?.length > 0) ? 'needs-completion' : ''} ${(canGoToStep3.duplicateContact === contatto) ? 'duplicate-contact' : ''}`" v-tooltip="{value: canGoToStep3.duplicateContact === contatto ? 'Contatto da selezionare' : 'Seleziona per completare il contatto', disabled: canGoToStep3.duplicateContact !== contatto && !(contatto.invalid_fields?.length > 0)}" @click="onSelectedContact(contatto)">
                    <span v-if="canGoToStep3.duplicateContact === contatto" class="duplicate-contact-badge" title="Seleziona questo contatto"><span aria-hidden="true">&#128073;</span><span class="p-sr-only">Seleziona questo contatto</span></span>
                    <span v-if="contatto.same_to_client" class="same-client-badge">Sede legale cliente</span>
                    <p class="m-0">
                      <span class="contact-label">Indirizzo:</span>
                      {{ `${contatto.toponimo ?? ''} ${contatto.indirizzo ?? ''} ${contatto.civico ?? ''}, ${contatto.cap ?? ''} - ${contatto.nome_comune ?? ''} ${contatto.provincia ?? ''}` }}
                    </p>
                    <div v-if="contatto.invalid_fields?.includes('toponimo')" class="contact-data invalid-contact-data">
                      <span class="contact-label">Toponimo:</span> {{ contatto.toponimo || 'Mancante' }}<span v-if="contatto.toponimo"> (Dato errato)</span>
                    </div>
                    <div v-if="contatto.invalid_fields?.includes('indirizzo')" class="contact-data invalid-contact-data">
                      <span class="contact-label">Indirizzo:</span> Mancante
                    </div>
                    <div v-if="contatto.invalid_fields?.includes('civico')" class="contact-data invalid-contact-data">
                      <span class="contact-label">Civico:</span> Mancante
                    </div>
                    <div v-if="contatto.invalid_fields?.includes('cap')" class="contact-data invalid-contact-data">
                      <span class="contact-label">CAP:</span> {{ contatto.cap || 'Mancante' }}<span v-if="contatto.cap"> (Dato errato)</span>
                    </div>
                    <div class="contact-data" :class="{'invalid-contact-data': contatto.invalid_fields?.includes('cell')}">
                      <span class="contact-label">Cellulare:</span> {{ contatto.cell !== '' && contatto.cell != null ? contatto.cell : 'Mancante' }}<span v-if="contatto.cell !== '' && contatto.cell != null && contatto.invalid_fields?.includes('cell')"> (Dato errato)</span>
                    </div>
                    <div class="contact-data" :class="{'invalid-contact-data': contatto.invalid_fields?.includes('email')}">
                      <span class="contact-label">Email:</span> {{ contatto.email !== '' && contatto.email != null ? contatto.email : 'Mancante' }}<span v-if="contatto.email !== '' && contatto.email != null && contatto.invalid_fields?.includes('email')"> (Dato errato)</span>
                    </div>
                    <div v-if="contatto.pec || contatto.invalid_fields?.includes('pec')" class="contact-data" :class="{'invalid-contact-data': contatto.invalid_fields?.includes('pec')}">
                      <span class="contact-label">PEC:</span> {{ contatto.pec !== '' && contatto.pec != null ? contatto.pec : 'Mancante' }}<span v-if="contatto.pec !== '' && contatto.pec != null && contatto.invalid_fields?.includes('pec')"> (Dato errato)</span>
                    </div>
                    <p v-if="canUsePecBypass && hasPecBypass(contatto) && getPecBypassReason(contatto)" class="m-0 p-error">
                      <span class="contact-label">Motivo bypass PEC:</span> {{ getPecBypassReason(contatto) }}
                    </p>
                  </Button>
                </div>
              </div>
              <div v-if="rappresentante.exist && contatti.length" class="col-12 flex justify-content-center mt-3">
                <Button label="Aggiungi nuovo contatto" icon="pi pi-plus" class="p-button-sm card-primary btn-reset" @click="addNewContact"/>
              </div>
              <div v-if="newContatto && !selectedContact" ref="repairFormRef" class="grid mt-3 p-2" :class="{'contact-repair-form': repairSourceContactId}">
                <div class="grid mt-3">
                  <div class="p-field col-12">
                    <h5>Indirizzo di spedizione</h5>
                    <small v-if="repairSourceContactId">Completa i dati mancanti o non validi per aggiornare il contatto.</small>
                    <hr>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4">
                    <label for="telefono">Telefono</label><br>
                    <InputText id="telefono" v-model="contatto.telefono" :disabled="isRepairFieldLocked('telefono')" class="inputfield w-full"/>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('cellulare')}">
                    <label for="cellulare">Cellulare <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('cellulare')" class="completion-note">da completare per proseguire</span></label><br>
                    <InputText v-if="repairSourceContactId && !isRepairFieldLocked('cellulare')" id="cellulare" v-model="contatto.cellulare" class="inputfield w-full" />
                    <InputMask v-else @change="onSelectedMobile($event)" id="cellulare" mask="999-999999?9" v-model="contatto.cellulare" :disabled="isRepairFieldLocked('cellulare')" class="inputfield w-full" />
  
                    <small v-show="validationErrors.cellulare_incorrect" class="p-error">Ricontrolla il numero di cellulare inserito.</small>
                  </div>
                  <Dialog id="modalShow" v-model:visible="showModal" :style="{width: '450px'}" :modal="true">
                    <div class="confirmation-content">          
                      <p>Hai inserito il numero telefonico: {{ contatto.cellulare }}</p> 
                      <p>É corretto?</p>   
                    </div>
                    <template #footer>
                      <Button @click="isCorrect(true)" label="Si" type="button" icon="pi pi-check" iconPos="left" class="p-button-success btn-multisito m-2" />
                      <Button @click="isCorrect()" label="No" type="button" icon="pi pi-times" iconPos="left" class="p-button-danger btn-multisito m-2" />
                    </template>
                  </Dialog>  
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('email')}">
                      <label for="email">Email <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('email')" class="completion-note">da completare per proseguire</span></label><br>
                      <InputText @change="onSelected($event)" id="email" v-model="contatto.email" :disabled="isRepairFieldLocked('email')" class="inputfield w-full" @input="onInputText"/>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('toponimo')}">
                      <label for="toponimo">Toponimo <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('toponimo')" class="completion-note">da completare per proseguire</span></label><br>
                      <Dropdown v-model="contatto.toponimo" :disabled="isRepairFieldLocked('toponimo')" :options="toponimi" optionLabel="name" :filter="true" optionValue="name" placeholder="Seleziona toponimo" class="inputfield w-full"/>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('indirizzo')}">
                      <label for="indirizzo">Indirizzo <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('indirizzo')" class="completion-note">da completare per proseguire</span></label><br>
                      <InputText v-model="contatto.indirizzo" :disabled="isRepairFieldLocked('indirizzo')" class="inputfield w-full" @input="(val) => (contatto.indirizzo = contatto.indirizzo.toUpperCase())"/>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('civico')}">
                      <label>Civico <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('civico')" class="completion-note">da completare per proseguire</span></label><br>
                      <InputText @change="onSelected($event)" v-model="contatto.civico" :disabled="isRepairFieldLocked('civico')" class="inputfield w-full" @input="(val) => (contatto.civico = contatto.civico.toUpperCase())"/>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('provincia')}">
                      <label>Provincia <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('provincia')" class="completion-note">da completare per proseguire</span></label><br>
                      <Dropdown @change="onSelectedDistrict($event)" v-model="contatto.provincia" :disabled="isRepairFieldLocked('provincia')" :options="districts" optionLabel="name" optionValue="code" :filter="true" placeholder="Seleziona provincia" class="inputfield w-full" />
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('cod_comune')}">
                      <label>Comune <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('cod_comune')" class="completion-note">da completare per proseguire</span></label><br>
                      <Dropdown @change="onSelectedCity($event)" v-model="contatto.cod_comune" :disabled="isRepairFieldLocked('cod_comune') || !contatto.provincia" :options="cities" optionLabel="name" optionValue="id" :filter="true" placeholder="Seleziona comune" class="inputfield w-full" />
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('cap')}">
                    <label for="cap">Cap <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('cap')" class="completion-note">da completare per proseguire</span></label><br>
                    <div v-tooltip.top="{value: 'È necessario selezionare prima il comune', disabled: Boolean(contatto.cod_comune)}" class="w-full">
                      <div v-if="contactCapSettings.isWildcard" class="p-inputgroup">
                        <span class="p-inputgroup-addon contact-cap-prefix">{{ contactCapSettings.cap.slice(0, 3) }}</span>
                        <input type="text" inputmode="numeric" maxlength="2" placeholder="Ultime 2 cifre" aria-label="Ultime due cifre del CAP" @input="onContactCapSuffixInput" @change="onSelected($event)" id="cap" :value="contactCapSuffix" :disabled="isRepairFieldLocked('cap')" class="p-inputtext p-component inputfield w-full">
                      </div>
                      <InputMask v-else :mask="contactCapSettings.mask" @change="onSelected($event)" id="cap" v-model="contatto.cap" :disabled="isRepairFieldLocked('cap') || !contatto.cod_comune || (!repairSourceContactId && contactCapSettings.isFixed)" class="inputfield w-full"></InputMask>
                    </div>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('pec')}">
                      <div class="flex justify-content-between align-items-center">
                        <label for="pec">Pec <span v-if="[1,3,4].includes(typeClient) && !(canUsePecBypass && bypass_pec)" class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('pec')" class="completion-note">da completare per proseguire</span></label>
                        <div v-if="canUsePecBypass" class="flex align-items-center">
                          <Checkbox inputId="bypass_pec" v-model="bypass_pec" :disabled="isRepairFieldLocked('pec') || isRepairFieldLocked('bypass_pec')" :binary="true" @update:modelValue="changeBypassPec"/>
                          <label for="bypass_pec" class="ml-2">Bypass Pec</label>
                        </div>
                      </div>
                      <InputText id="pec" v-model="contatto.pec" class="inputfield w-full" @input="onInputText" :disabled="isRepairFieldLocked('pec') || (canUsePecBypass && bypass_pec)"/>
                      <div v-if="canUsePecBypass && bypass_pec" class="mt-2" :class="{'contact-field-to-complete': needsContactCompletion('bypass_pec_reason')}">
                        <label for="bypass_pec_reason">Motivo del bypass <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('bypass_pec_reason')" class="completion-note">da completare per proseguire</span></label><br>
                        <Textarea id="bypass_pec_reason" v-model="bypass_pec_reason" :disabled="isRepairFieldLocked('bypass_pec')" class="inputfield w-full" rows="2"/>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="grid justify-content-between">
          <Button label="Indietro" @click="prevPage()" icon="pi pi-angle-left" iconPos="left" class="p-btn-footer card-primary btn-reset"/>
          <div class="flex flex-column gap-2 mt-2">
            <InlineMessage v-if="canGoToStep3.disabled" severity="warn" class="w-full justify-content-start">
              {{ canGoToStep3.message }}
            </InlineMessage>

            <Button v-if="!canGoToStep3.disabled" label="Avanti" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" class="p-btn-footer card-primary btn-reset"/>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import TutorialDialog from './TutorialDialog.vue'
import {ref, getCurrentInstance, onMounted, computed, onUpdated, onActivated, watch, nextTick } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useToast } from 'primevue/usetoast';
import { useStore } from 'vuex'
import Dialog from 'primevue/dialog';
import { useRoute } from 'vue-router';
import Opzioni from '@/config/opzioni'
import services from '@/config/services'
import { findDuplicateContact } from './contactComparison'
import { getContactCapSettings, isContactCapValid, withContactAddressValidation } from './contactAddressValidation'

export default {
  components: {
    TutorialDialog
  },
  props: {
    formData: Object
  },
  emits: [
    'activeLoader', 
    'activeLoaderCaricamento', 
    'prev-page', 
    'next-page', 
    'complete'
  ],
  setup (props, {emit}) {
    const store = useStore()
    const currentUser = ref()
    const isAdmin = computed(() => currentUser.value?.role === 'admin')
    const loading = ref(true)
    const route = useRoute()
    const toast = useToast();
    const stepIndex = 1
    const activeTabIndex = ref(0)
    const rappresentante = ref({})
    const rappresentanteDetailUrl = computed(() => isAdmin.value && rappresentante.value.id
      ? `${services.admin.url.replace(/\/$/, '')}/ask/rappresentanti/${encodeURIComponent(rappresentante.value.id)}/dettagli`
      : null)
    const rappresentanti = ref([])
    const newContatto = ref(false)
    const sameAddress = ref(false)
    const contatto = ref({id: 0})
    const contatti = ref([])
    const selectedContact = ref(null)
    const repairSourceContactId = ref(null)
    const repairLockedFields = ref({})
    const repairInitialValues = ref({})
    const repairFormRef = ref(null)
    const selectedFormaGiuridicaName = ref()
    const selectedFormaGiuridica = ref()
    const initializedKey = ref(null)
    const initializing = ref(false)
    const forme_giuridiche = ref([
      {key: 0, value: 'Persona fisica'},
      {key: 1, value: 'Persona giuridica'}
    ])
    const updateSelectedFormaGiuridica = () => {
      selectedFormaGiuridica.value = forme_giuridiche.value.find(item => item.value == selectedFormaGiuridicaName.value)
    }
    
    const cities = ref([])
    const opzioni = new Opzioni()
    const districts = opzioni.province
    const toponimi = opzioni.toponimi
    const contactCapSettings = computed(() => getContactCapSettings(contatto.value.cod_comune, opzioni.comuni))
    const contactCapSuffix = computed({
      get: () => {
        if (!contactCapSettings.value.isWildcard) return ''
        const prefix = contactCapSettings.value.cap.slice(0, 3)
        const cap = String(contatto.value.cap ?? '').replace(/\D/g, '')
        return cap.startsWith(prefix) ? cap.slice(3, 5) : ''
      },
      set: value => {
        const prefix = contactCapSettings.value.cap.slice(0, 3)
        const suffix = String(value ?? '').replace(/\D/g, '').slice(0, 2)
        contatto.value.cap = `${prefix}${suffix}`
      }
    })
    const onContactCapSuffixInput = event => {
      const suffix = String(event.target.value ?? '').replace(/\D/g, '').slice(0, 2)
      event.target.value = suffix
      contactCapSuffix.value = suffix
    }

    const format = ref(false) 
    const isEmail = ref(false)
    const validationErrors = ref({})
    const submitted = ref(false)
    const type_insert = ref([
      {key:0, name:'Completo'},
      {key:1, name:'Temporaneo'}
    ]);
    const selectedTypeInsert = ref(0)

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const typeClient = ref(null);
    const showModal = ref(false)
    const windowSize = ref(window.innerWidth)
    const slides = ref([])
    const canUseClientAddress = computed(() => {
      const cliente = props.formData.cliente || {}
      const requiredAddressFields = [
        cliente.toponimo,
        cliente.indirizzo,
        cliente.civico,
        cliente.cap,
        cliente.provincia,
        cliente.cod_comune
      ]
      if([1,3,4].includes(typeClient.value) && !(canUsePecBypass.value && bypass_pec.value)) requiredAddressFields.push(cliente.pec)

      return typeClient.value != 3 && requiredAddressFields.every(field => field !== null && field !== undefined && String(field).trim() !== '')
    })
    const dati_matrice_da_modificare = ref({
      rappresentante: {
        codfis: null
      }
    })
    const loaded_rappresentante = ref(true)
    const cf = ref()
    const getNormalizedContatto = (contact = {}) => {
      const normalized = {...contact}
      normalized.cellulare = normalized.cellulare || normalized.cell || ''
      normalized.cell = normalized.cell || normalized.cellulare || ''
      normalized.nome_comune = normalized.nome_comune || normalized.name || ''
      normalized.same_to_client = Boolean(normalized.same_to_client)

      return normalized
    }
    const bypass_pec = ref(false)
    const bypass_pec_reason = ref('')
    const supportsPecBypass = ref(false)
    const canUsePecBypass = computed(() => isAdmin.value && supportsPecBypass.value)
    const hasPecBypass = (contact = {}) => {
      if (contact.bypass_pec && typeof contact.bypass_pec === 'object') {
        return contact.bypass_pec.value === true || Number(contact.bypass_pec.value) === 1
      }

      return Number(contact.bypass_pec) === 1
    }
    const getPecBypassReason = (contact = {}) => {
      if (contact.bypass_pec && typeof contact.bypass_pec === 'object') {
        return contact.bypass_pec.reason || ''
      }

      return contact.motivazione_bypass_pec || ''
    }
    const resetContactRepair = () => {
      repairSourceContactId.value = null
      repairLockedFields.value = {}
      repairInitialValues.value = {}
    }
    const hasValue = value => value !== null && value !== undefined && String(value).trim() !== ''
    const needsContactCompletion = field => {
      if (!repairSourceContactId.value || repairLockedFields.value[field]) return false
      if (field === 'pec' && (![1,3,4].includes(typeClient.value) || (canUsePecBypass.value && bypass_pec.value))) return false
      if (field === 'bypass_pec_reason') return canUsePecBypass.value && bypass_pec.value && !hasValue(bypass_pec_reason.value)
      if (field === 'cap') return !isContactCapValid(contatto.value.cap, contatto.value.cod_comune, opzioni.comuni)
      const value = contatto.value[field]
      return (hasValue(value) && value === repairInitialValues.value[field]) || !hasValue(['cellulare', 'cap'].includes(field) ? String(value || '').replace(/[_\s-]/g, '') : value)
    }
    const optionName = value => String(value?.name ?? value ?? '').trim().toLocaleUpperCase()
    const isValidMobile = value => {
      const mobile = String(value || '').replace(/\D/g, '')
      return /^3\d{8,9}$/.test(mobile)
        && !/^(\d)\1+$/.test(mobile)
        && !/^3(\d)\1+$/.test(mobile)
        && !['3123456789', '3234567890', '3987654321', '3098765432'].includes(mobile)
    }
    const isValidEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())
    const getCompleteContactFields = contact => {
      if (Array.isArray(contact.complete_fields)) return [...contact.complete_fields]
      const normalized = getNormalizedContatto(contact)
      const invalidFields = new Set(contact.invalid_fields || [])
      const contactCities = normalized.provincia ? opzioni.getCities(normalized.provincia) : []
      const validBypass = !invalidFields.has('pec') && canUsePecBypass.value && hasPecBypass(normalized)
      const checks = {
        telefono: hasValue(normalized.telefono || normalized.tel),
        cellulare: !invalidFields.has('cell') && isValidMobile(normalized.cellulare),
        email: !invalidFields.has('email') && isValidEmail(normalized.email),
        pec: !invalidFields.has('pec') && isValidEmail(normalized.pec),
        bypass_pec: validBypass,
        toponimo: toponimi.some(item => optionName(item.name) === optionName(normalized.toponimo)),
        indirizzo: hasValue(normalized.indirizzo),
        civico: hasValue(normalized.civico),
        cap: !invalidFields.has('cap') && isContactCapValid(normalized.cap, normalized.cod_comune, opzioni.comuni),
        provincia: districts.some(item => optionName(item.code) === optionName(normalized.provincia)),
        cod_comune: contactCities.some(item => item.id == normalized.cod_comune)
      }
      return Object.keys(checks).filter(field => checks[field])
    }
    const withCompleteContactFields = contact => {
      const normalized = withContactAddressValidation(getNormalizedContatto(contact), toponimi, opzioni.comuni)
      normalized.complete_fields = getCompleteContactFields(normalized)
      return normalized
    }
    const isRepairFieldLocked = field => {
      if (!repairSourceContactId.value) return false
      return contatto.value.complete_fields?.includes(field) === true
    }
    const completeContact = (source) => {
      const invalidFields = new Set(source.invalid_fields || [])
      const repaired = withCompleteContactFields(source)
      delete repaired.invalid_fields
      delete repaired.selectable
      repaired.id = source.id
      repaired.updated = true
      repaired.prev_id = source.id
      repaired.cod_rapp = source.cod_rapp ?? rappresentante.value.id
      repaired.selected = false
      repaired.same_to_client = false
      repaired.telefono = repaired.telefono || repaired.tel || ''
      if (invalidFields.has('pec')) {
        repaired.bypass_pec = false
        repaired.motivazione_bypass_pec = ''
      }
      const provinceOption = districts.find(item => optionName(item.name) === optionName(repaired.provincia))
        || districts.find(item => optionName(item.code) === optionName(repaired.provincia))
      const provinceValid = Boolean(provinceOption)
      repaired.provincia = provinceOption?.code ?? repaired.provincia
      cities.value = provinceValid ? opzioni.getCities(repaired.provincia) : []
      const cityOption = cities.value.find(item => optionName(item.name) === optionName(repaired.nome_comune || repaired.comune || repaired.cod_comune))
        || cities.value.find(item => item.id == repaired.cod_comune)
      const cityValid = Boolean(cityOption)
      if (cityValid) {
        repaired.cod_comune = cityOption.id
        repaired.nome_comune = cityOption.name
        if (!isContactCapValid(repaired.cap, cityOption.id, opzioni.comuni)) {
          repaired.cap = getContactCapSettings(cityOption.id, opzioni.comuni).prefill
        }
      }
      const toponimoOption = toponimi.find(item => optionName(item.name) === optionName(repaired.toponimo))
      repaired.toponimo = toponimoOption?.name ?? repaired.toponimo
      const validBypass = !invalidFields.has('pec') && canUsePecBypass.value && hasPecBypass(repaired)
      bypass_pec.value = validBypass
      bypass_pec_reason.value = validBypass ? getPecBypassReason(repaired) : ''
      repairLockedFields.value = repaired.complete_fields.reduce((fields, field) => {
        fields[field] = true
        return fields
      }, {})
      repairInitialValues.value = {...repaired}
      repairSourceContactId.value = source.id
      removeSameAddressContact()
      contatti.value.forEach(contact => { contact.selected = false })
      selectedContact.value = null
      sameAddress.value = false
      newContatto.value = true
      contatto.value = repaired
      submitted.value = false
      validationErrors.value = {}
      nextTick(() => repairFormRef.value?.scrollIntoView({behavior: 'smooth', block: 'start'}))
    }
    const changeBypassPec = (value) => {
      if (!canUsePecBypass.value) {
        bypass_pec.value = false
        bypass_pec_reason.value = ''
        return
      }

      if (!value) {
        bypass_pec_reason.value = ''
      }else{
        contatto.value.pec = ''
      }
    }
    const getClienteContactPhone = () => {
      const cliente = props.formData.cliente || {}

      return cliente.cellulare || cliente.cell || ''
    }

    const removeSameAddressContact = () => {
      contatti.value = contatti.value.filter(contact => !contact.same_to_client)
    }

    const getSameAddressContact = () => {
      const clienteAddress = getClienteAddressContact()
      const contactPhone = contatto.value.cellulare || contatto.value.cell || clienteAddress.cell || ''

      return getNormalizedContatto({
        id: 0,
        same_to_client: false,
        selected: true,
        ...clienteAddress,
        name: clienteAddress.nome_comune || '',
        email: contatto.value.email || clienteAddress.email || '',
        cellulare: contactPhone,
        cell: contactPhone
      })
    }

    const getIndexSelectedContact = (id = null) => {
      if (id) {
        const indexById = contatti.value.findIndex(contact => contact.id == id)
        if (indexById >= 0) return indexById
      }

      const indexSelected = contatti.value.findIndex(contact => contact.selected)
      return indexSelected >= 0 ? indexSelected : (contatti.value.length ? 0 : -1)
    }

    const setSelectedContact = (contact = null) => {
      if (contact?.invalid_fields?.length > 0) {
        completeContact(contact)
        return
      }
      resetContactRepair()
      if (!contact) {
        selectedContact.value = null
        return
      }

      const normalized = getNormalizedContatto(contact)
      selectedContact.value = normalized
      contatto.value = normalized
      newContatto.value = false
      bypass_pec.value = hasPecBypass(normalized)
      bypass_pec_reason.value = getPecBypassReason(normalized)
      if (!normalized.same_to_client) removeSameAddressContact()
      contatti.value.forEach(existingContact =>{
        existingContact.selected = existingContact.id == normalized.id
      })
      sameAddress.value = normalized.same_to_client
      if (normalized.provincia) cities.value = opzioni.getCities(normalized.provincia)
    }

    const setContattiFromBackend = (backendContacts = [], option = {}) => {
      contatti.value = backendContacts
        .map(contact => {
          return {...withCompleteContactFields(contact), same_to_client: false, selected: Boolean(contact.selected)}
        })

      const hasBackendContacts = contatti.value.length > 0
      if (!hasBackendContacts) {
        if (canUseClientAddress.value) {
          sameAddress.value = true
          setSameAddress()
        } else {
          sameAddress.value = false
          selectedContact.value = null
          newContatto.value = true
        }
        return
      }

      const restoreNewContact = option.nuovo_contatto === true
        && Number(option.contatto || 0) === 0
        && Number(option.prev_contatto_id || 0) > 0
      if (restoreNewContact) {
        const indexNewContact = contatti.value.findIndex(contact => contact.id == option.prev_contatto_id)
        if (indexNewContact >= 0) {
          const restoredContact = {
            ...getNormalizedContatto(contatti.value[indexNewContact]),
            id: 0,
            prev_id: option.prev_contatto_id,
            selected: false,
            same_to_client: false
          }
          delete restoredContact.updated
          delete restoredContact.complete_fields
          delete restoredContact.invalid_fields
          delete restoredContact.selectable
          contatti.value.splice(indexNewContact, 1)
          contatti.value.forEach(contact => { contact.selected = false })
          resetContactRepair()
          selectedContact.value = null
          sameAddress.value = false
          newContatto.value = true
          contatto.value = restoredContact
          bypass_pec.value = hasPecBypass(restoredContact)
          bypass_pec_reason.value = getPecBypassReason(restoredContact)
          if (restoredContact.provincia) cities.value = opzioni.getCities(restoredContact.provincia)
          return
        }
      }

      newContatto.value = false
      const idContatto = option.prev_contatto_id || option.contatto || null
      const indexContatto = getIndexSelectedContact(idContatto)
      if (indexContatto < 0) {
        selectedContact.value = null
        newContatto.value = true
        sameAddress.value = false
        return
      }
      setSelectedContact(contatti.value[indexContatto])

      if (option.prev_contatto_id) contatto.value.prev_id = option.prev_contatto_id
      if (contatto.value.cod_comune) contatto.value.nome_comune = opzioni.getNameCityById(contatto.value.cod_comune)
    }

    const getClienteAddressContact = () => {
      const cliente = props.formData.cliente || {}

      return {
        toponimo: cliente.toponimo || '',
        indirizzo: cliente.indirizzo || '',
        civico: cliente.civico || '',
        cap: cliente.cap || '',
        provincia: cliente.provincia || null,
        cod_comune: cliente.cod_comune || null,
        nome_comune: cliente.nome_comune || '',
        email: cliente.email || '',
        cellulare: getClienteContactPhone(),
        cell: getClienteContactPhone(),
      }
    }

    const setSameAddress = () => {
      if (sameAddress.value && !canUseClientAddress.value) {
        sameAddress.value = false
        removeSameAddressContact()
        selectedContact.value = null
        newContatto.value = true
        return
      }

      if (!sameAddress.value) {
        removeSameAddressContact()
        selectedContact.value = null
        newContatto.value = true
        contatti.value.forEach(contact =>{
          contact.selected = false
        })
        contatto.value = {
          ...contatto.value,
          toponimo: "",
          indirizzo: "",
          civico: "",
          cap: "",
          provincia: null,
          cod_comune: null,
          nome_comune: ""
        }
        cities.value = []
        return
      }

      removeSameAddressContact()
      contatti.value.forEach(contact =>{
        contact.selected = false
      })
      const sameAddressContact = getSameAddressContact()
      contatti.value.unshift(sameAddressContact)
      setSelectedContact(sameAddressContact)
    }

    const inputCF = async (option = {}) => {
      cf.value = cf.value.toUpperCase()
      let required_elements = {
        cf: cf.value
      }
      
      let can_check_exist_rapp = Object.values(required_elements).every(el => el !== null)
      
      if (can_check_exist_rapp) {
        loaded_rappresentante.value = false
        supportsPecBypass.value = false

        emit("activeLoader", true)
        await service.check_exist_rapp(
          {
            id_client: props.formData.cliente.id,
            cod_type_client: props.formData.typeClient,
            datas: required_elements
          }
        )
        .then((res)=>{
          let data = res.res.data
          supportsPecBypass.value = data.supports_bypass_pec === true
          
          initRappresentante()
          if (data.exist) {
            toast.add({severity:'success', detail:'Rappresentante presente'})

            rappresentante.value = data.rappresentante
            if ('prev_id' in option) rappresentante.value.prev_id = option.prev_id
            setContattiFromBackend(data.contatti || [], option)
            if (newContatto.value) {
              rappresentante.value.can_view = true
              emit("activeLoader", false)
            }
          } else {
            newContatto.value = true
            selectedContact.value = null
            sameAddress.value = false
            rappresentante.value.can_view = true
            rappresentante.value.codfis = cf.value
            emit("activeLoader", false)
          }
          rappresentante.value.exist = data.exist
        })
        .finally(()=>{
          loaded_rappresentante.value = true
          emit("activeLoader", false)
          rappresentante.value.can_view = true
        })
      }
    }
    const initRappresentante = (force = false) => {
      rappresentante.value = {
        exist: null,
        can_view: false,
        id: 0,
        prev_id: 0,
        name: "",
        codfis: ""
      }
      contatto.value = {
        id: 0,
        prev_id: 0,
        toponimo: "",
        indirizzo: "",
        civico: "",
        cap: "",
        email: "",
        pec: null,
        tel: null,
        cell: "",
        cellulare: "",
        fax: null,
        cod_rapp: 0,
        cod_comune: null,
        selected: false,
        name: "",
        provincia: ""
      }
      newContatto.value = false
      sameAddress.value = false
      selectedContact.value = null
      resetContactRepair()
      contatti.value = []
      bypass_pec.value = false
      bypass_pec_reason.value = ''
      validationErrors.value = {}
      if (force) {
        selectedFormaGiuridica.value = forme_giuridiche.value[0]
        selectedFormaGiuridicaName.value = selectedFormaGiuridica.value.value
        cf.value = null
      }
    }

    const hasValidRouteId = () => {
      return Boolean(route.params.id && route.params.id !== 'null' && route.params.id !== 'undefined')
    }

    const isStepRappresentanteRoute = () => route.path.startsWith('/multisito/step-rappresentante')

    const getInitializeKey = () => {
      return [
        route.params.id || 'new',
        route.query.reload || '',
        props.formData?.typeClient || '',
        props.formData?.cliente?.id || props.formData?.cliente?.codfis || '',
        props.formData?.rappresentante?.id || props.formData?.rappresentante?.prev_id || props.formData?.rappresentante?.codfis || ''
      ].join('::')
    }

    const syncFromFormData = () => {
      if (!props.formData?.rappresentante) return false

      rappresentante.value = {
        ...props.formData.rappresentante,
        can_view: true,
        exist: props.formData.rappresentante.exist ?? Boolean(props.formData.rappresentante.id)
      }

      cf.value = rappresentante.value.codfis || ''
      if (cf.value) {
        const indexFormaGiuridica = cf.value.length == 16 ? 0 : 1
        selectedFormaGiuridica.value = forme_giuridiche.value[indexFormaGiuridica]
        selectedFormaGiuridicaName.value = selectedFormaGiuridica.value.value
      }

      if (props.formData.contatto) {
        if (Array.isArray(props.formData.representativeProposedContacts)) {
          contatti.value = props.formData.representativeProposedContacts.map(contact => ({
            ...withCompleteContactFields(contact),
            selected: false
          }))
        }
        const normalizedContatto = getNormalizedContatto(props.formData.contatto)
        contatto.value = normalizedContatto
        bypass_pec.value = hasPecBypass(normalizedContatto)
        bypass_pec_reason.value = getPecBypassReason(normalizedContatto)
        sameAddress.value = Boolean(normalizedContatto.same_to_client)

        if ((normalizedContatto.id && !normalizedContatto.updated) || normalizedContatto.same_to_client) {
          resetContactRepair()
          const index = contatti.value.findIndex(contact => contact.id == normalizedContatto.id)
          const selected = {...normalizedContatto, selected: true}
          if (index >= 0) contatti.value[index] = selected
          else contatti.value.unshift(selected)
          selectedContact.value = selected
          newContatto.value = false
        } else {
          selectedContact.value = null
          newContatto.value = true
          const repair = props.formData.representativeContactRepair
          if (repair?.sourceId && normalizedContatto.prev_id == repair.sourceId) {
            repairSourceContactId.value = repair.sourceId
            repairLockedFields.value = {...repair.lockedFields}
        repairInitialValues.value = {...repair.initialValues}
          } else {
            resetContactRepair()
          }
        }

        if (normalizedContatto.provincia) cities.value = opzioni.getCities(normalizedContatto.provincia)
      }

      loaded_rappresentante.value = true
      loading.value = false
      emit("activeLoaderCaricamento", false)
      emit("activeLoader", false)

      return true
    }

    const initializeStepRappresentante = async () => {
      currentUser.value = store.state.auth.user

      if (!isStepRappresentanteRoute()) return

      const initializeKey = getInitializeKey()
      if (initializing.value || (initializedKey.value === initializeKey && !loading.value)) return

      initializing.value = true
      try {
        if (JSON.stringify(props.formData) === "{}") {
          loading.value = false
          emit("activeLoaderCaricamento", false)
          return
        }
        
        initRappresentante(true)
        
        loading.value = true
        setResponsive()
        await getSlides()
        emit("activeLoaderCaricamento", true)
        typeClient.value = props.formData.typeClient

        if (hasValidRouteId()) {
          await getDataMatrice()
        }else{
          if (syncFromFormData()) {
            const selectedContactId = props.formData.contatto?.id || null
            if (cf.value) {
              await inputCF({force: true, contatto: selectedContactId})
            }
            if (props.formData.representativeContactRepair?.sourceId) syncFromFormData()
            initializedKey.value = initializeKey
            return
          }

          if (props.formData.cliente && props.formData.cliente.id && props.formData.cliente.codfis_rapp) {
            cf.value = props.formData.cliente.codfis_rapp
            await inputCF()
          }
          emit("activeLoaderCaricamento", false)
          loading.value = false
        }
        initializedKey.value = initializeKey
      } finally {
        initializing.value = false
      }
    }

    onMounted(initializeStepRappresentante)
    onActivated(initializeStepRappresentante)
    watch(
      () => [route.path, getInitializeKey()],
      () => initializeStepRappresentante()
    )


    const getDataMatrice = async () => {
      await service.getDataMatrice(stepIndex, route.params.id)
      .then((res)=>{
        if (!res.res.data.success) {
          toast.add({severity: 'warn', summary: 'Attenzione', detail: res.res.data.message});
          emit('complete')
        }else{
          let data = res.res.data.data  
  
          let index_forma_giuridica = data.rappresentante.codfis.length == 16 ? 0 : 1
          selectedFormaGiuridica.value = forme_giuridiche.value[index_forma_giuridica]

          cf.value = data.rappresentante.codfis
          let option = {
            force: true,
            contatto: data.rappresentante.contatto_id,
            nuovo_contatto: data.rappresentante.nuovo_contatto === true
          }
          if(data.rappresentante.nuovo_rappresentante) option.prev_id = data.rappresentante.prev_id
          if (option.nuovo_contatto) option.prev_contatto_id = data.rappresentante.prev_contatto_id    

          inputCF(option)  
          dati_matrice_da_modificare.value = {...data}
          if(data.nuovo_rappresentante){
            activeTabIndex.value = 1
            onSelectedView()
            
            rappresentante.value = {...data.rappresentante}
            onSelectedDistrict({value: data.contatto.provincia_spedizione}, 'spedizione')
            rappresentante.value.comune_legale = dati_matrice_da_modificare.value.contatto.comune_legale
          }
        }
      })
      .finally(()=>{
        emit("activeLoaderCaricamento", false)
        loading.value = false
      })
    }


    const setResponsive = () => {
      window.addEventListener('resize', () => {
        windowSize.value = window.innerWidth
      })
    }


    const getSlides = async () => {
      await service.getSlides(stepIndex)
      .then((res) => {
        slides.value = res.items
        slides.value.forEach(slide => {
          slide.name = `/images/Step/step${stepIndex}-${slide.order}.png`
        })
      })
    }

    const onSelectedTypeInsert = () => {
      validationErrors.value = []
      if(selectedTypeInsert.value == 1){
        contatto.value = {id: 0}
        delete rappresentante.value.codfis
      }
    }

    const status_percent_rapp = computed(() => {
      let validate_properties = [
          'codfis',
          'nome',
          'cognome',
          'email',
          'cellulare',
          'toponimo_spedizione',
          'indirizzo_spedizione',
          'civico_spedizione',
          'cap_spedizione',
          'provincia_spedizione',
          'comune_spedizione'
        ]
          let total = 0;
          validate_properties.forEach(element => {
            switch (element) {
              case 'codfis':
              case 'nome':
              case 'cognome':
                if (rappresentante.value[element] != '' && rappresentante.value[element] != null && rappresentante.value[element] != 0) {
                  total += 100 / validate_properties.length;
                }
                break;
              default:
                if (contatto.value[element] != '' && contatto.value[element] != null && contatto.value[element] != 0) {
                  total += 100 / validate_properties.length;
                }
                break;
            }
          });
          return total;
    });

    const onSelectedToponimo = (evt, type) => {
      delete validationErrors.value[`toponimo_${type}`];
    }
    const onInputText = (evt) => {
      const field = evt.target.id
      if (!field) return

      if (['email', 'pec'].includes(field)) {
        contatto.value[field] = evt.target.value.toLowerCase()
        if (field === 'pec') bypass_pec_reason.value = ''

      } else {
        contatto.value[field] = evt.target.value.toUpperCase()
      }
    }

    const onSelectedView = () => {
      if (activeTabIndex.value == 0) {
        Object.keys(validationErrors.value).forEach((error) => {
          delete validationErrors.value[`${error}`]
        });
      }else{
        delete validationErrors.value.rappresentante
      }
    }

    const getRapps = async () =>{
      await service.getRappresentanti()
      .then((res) => {
        rappresentanti.value = res.items
      })
    }
    // const setRapps = () => {
    //   selectedRapp.value = props.formData.cliente?.rapp
    //   ? rappresentanti.value.find(rappresentante => rappresentante.id == props.formData.cliente.rapp) 
    //   : null

    //   if (selectedRapp.value != null) {
    //     onSelectedRapp()
    //   }
    // }
    // const getContatti = (id = null) => {
    //   service.getContacts(selectedRapp.value.id, 'rapp')
    //   .then((res) => {
    //     contatti.value = res.items.filter(el => el.email)
    //     contatti.value = contatti.value.filter(el => el.cell)
    //     newContatto.value = contatti.value.length == 0
        
    //     if (id) {
    //       let index_existent_contatto = contatti.value.findIndex(contatto => contatto.id == id)
    //       selectedContact.value = contatti.value[index_existent_contatto]
    //     } else if(!newContatto.value){
    //       selectedContact.value = contatti.value[contatti.value.length-1]
    //     }
    //   })
    // }
    // const onSelectedRapp = (id = null) => {  
    //   delete validationErrors.value['rappresentante'];
    //   newContatto.value = false
    //   contatti.value = []
    //   contatto.value = {id: 0}

    //   selectedContact.value = null
    //   getContatti(id)
    // }
    

    const onSelectedDistrict = (evt, obj = 'contatto') => {
      cities.value = opzioni.getCities(evt.value)
      if (obj === 'contatto') {
        contatto.value.cod_comune = null
        contatto.value.cap = ''
      }
      delete validationErrors.value['provincia_spedizione'];
    }
        
    const onSelectedCity = (evt) => {
      contatto.value.cod_comune = evt.value
      contatto.value.nome_comune = opzioni.getNameCityById(evt.value)
      contatto.value.cap = getContactCapSettings(evt.value, opzioni.comuni).prefill
    }
    const onSelectedMobile = (evt) => {
      contatto.value.cellulare = evt.target.value;
      showModal.value = true;
      delete validationErrors.value['cellulare_incorrect'];
      delete validationErrors.value['cellulare'];
    }

    const isCorrect = (is_correct = false) => {
      if (!is_correct) {
        validationErrors.value['cellulare_incorrect'] = true;
      }else{
        delete validationErrors.value['cellulare_incorrect'];
      }
      showModal.value = false;
    }

    const onSelectedContact = (contact) => {
      setSelectedContact(contact)
      delete validationErrors.value.contact;
    }

    const nextPage = async () => {
      submitted.value = true;
      emit("activeLoader", true)
      if (selectedContact.value && !newContatto.value) {
        contatto.value = getNormalizedContatto(contatto.value)
      }
      if (newContatto.value && sameAddress.value) setSameAddress()

      const rappresentantePayload = {...rappresentante.value}
      const contattoPayload = {...contatto.value}
      if (repairSourceContactId.value) contattoPayload.cell = String(contattoPayload.cellulare || '').replace(/\D/g, '')
      const usePecBypass = canUsePecBypass.value && bypass_pec.value
      contattoPayload.bypass_pec = {
        value: usePecBypass,
        reason: usePecBypass ? bypass_pec_reason.value : ''
      }

      emit('next-page', {
        formData: 
        {
          "rappresentante": rappresentantePayload,
          "contatto": contattoPayload,
          "representativeProposedContacts": contatti.value
            .filter(contact => !contact.same_to_client)
            .map(contact => ({...contact, selected: false})),
          "representativeContactRepair": repairSourceContactId.value
            ? {sourceId: repairSourceContactId.value, lockedFields: {...repairLockedFields.value}, initialValues: {...repairInitialValues.value}}
            : null
        }
        ,pageIndex: stepIndex
      })
      setTimeout(()=>{
        rappresentante.value.can_view = true
      }, 2000)
    }
    const prevPage = () => {
      emit('prev-page', {pageIndex: stepIndex});
    }
    const onSelected = (evt) => {
      if (evt.target.id == 'codfis') {
        delete validationErrors.value['codfis'];
        delete validationErrors.value['invalid'];
        delete validationErrors.value['format'];
        delete validationErrors.value['rappex'];
      }else{
        delete validationErrors.value[evt.target.id];
      }
    }

    // const validateForm = async () => {
    //   validationErrors.value = []
    //   if (activeTabIndex.value == 0) {
    //     if (selectedRapp.value == null) {
    //       validationErrors.value['rappresentante'] = true;
    //     } else {
    //       if (selectedContact.value) {
    //         contatto.value = selectedContact.value
    //       }else if(!newContatto.value){
    //         validationErrors.value['contact'] = true;
    //       }else{
    //         let validate_properties_contatto = [
    //           'email',
    //           'cellulare',
    //           'toponimo_spedizione',
    //           'indirizzo_spedizione',
    //           'civico_spedizione',
    //           'cap_spedizione_new',
    //           'provincia_spedizione',
    //           'comune_spedizione'
    //         ]

    //         Object.keys(contatto.value).forEach(element => {
    //           if(!element.includes('comune')){
    //             if (typeof contatto.value[element] == 'string') {
    //               contatto.value[element] = contatto.value[element].trim()
    //             }
    //           }
    //         });
    //         validate_properties_contatto.forEach(property => {
    //           if (Object.keys(contatto.value).includes(property) && contatto.value[property] != '') {
    //             delete validationErrors.value[property]
                
    //             if (property == 'email'){
    //               let regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //               !regex_email.test(contatto.value.email) ? validationErrors.value['isEmail'] = true : delete validationErrors.value['isEmail']
    //             }
    //           } else {
    //             validationErrors.value[property] = true
    //           }
    //         });
    //       }
    //       delete validationErrors.value['rappresentante'];
    //     }
    //   } else {

    //     if (rappresentante.value.codfis) {
    //       await validateRappExist()
    //     }
    //     let regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //     let regexPiva = /^[0-9]{11}$/
    //     let regex_cf = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
    //     let regex_alphanumeric = /[a-zA-Z]/

    //     let validate_properties = [
    //       'nome',
    //       'cognome',
    //       'codfis',
    //       'email',
    //       'cellulare',
    //       'toponimo_spedizione',
    //       'indirizzo_spedizione',
    //       'civico_spedizione',
    //       'cap_spedizione',
    //       'provincia_spedizione',
    //       'comune_spedizione'
    //     ]
        
    //     validate_properties.forEach(element => {
    //       let check = contatto.value[`${element}`] == '' || contatto.value[`${element}`] == null 
    //       switch (element) {          
    //         case 'codfis':
    //         case 'nome':
    //         case 'cognome':
    //           check = rappresentante.value[`${element}`] == '' || rappresentante.value[`${element}`] == null
    //           break;

    //         default:
    //           break;
    //       }
    //       if (check) {
    //         validationErrors.value[`${element}`] = true;
    //       }else{
    //         switch (element) {
    //           case 'codfis':
    //             if (regex_alphanumeric.test(rappresentante.value[`${element}`])) {
    //               if (!regex_cf.test(rappresentante.value[`${element}`])) 
    //                 validationErrors.value['format'] = true;
    //               else
    //                 delete validationErrors.value['format'];
    //             }else{
    //               if (typeClient.value == 3) {
    //                 if (!regexPiva.test(rappresentante.value[`${element}`]))
    //                   validationErrors.value['format'] = true;
    //                 else
    //                   delete validationErrors.value['format']       
    //               } else {
    //                 validationErrors.value['invalid'] = true;
    //               }
    //             }
    //             break;
    //           case 'email':
    //             if (!regex_email.test(contatto.value[`${element}`])){
    //               validationErrors.value['isEmail'] = true;
    //             }else{
    //               delete validationErrors.value['isEmail'];
    //             }
    //             break;

    //           default:
    //             break;
    //         }
    //       }
    //     });
    //   }
    //   return !Object.keys(validationErrors.value).length;
    // }

    const canGoToStep3 = computed(() => {
      const res = { disabled: false, message: "" };
      let requiredField = [];
      let emailToValidate = null;

      if (!loaded_rappresentante.value) return { disabled: true, message: "Attendi la ricerca del rappresentante." };
      if (rappresentante.value.exist === null) return { disabled: true, message: "Ricerca un rappresentante." }


      // --- 1. LOGICA TAB 0: RAPPRESENTANTE ESISTENTE ---
      if (!rappresentante.value.exist) {
        // Dati base sempre obbligatori
        requiredField = [
          { val: rappresentante.value.nome, label: 'Nome' },
          { val: rappresentante.value.cognome, label: 'Cognome' },
          { val: rappresentante.value.codfis, label: 'Codice Fiscale' },
        ];
      }
      
      const shouldValidateContact = newContatto.value || selectedContact.value?.same_to_client
      const duplicateContact = (newContatto.value || repairSourceContactId.value) && !sameAddress.value && findDuplicateContact({
        ...contatto.value,
        bypass_pec: {
          value: canUsePecBypass.value && bypass_pec.value,
          reason: bypass_pec_reason.value
        }
      }, contatti.value, isAdmin.value, typeClient.value == 2)
      if (duplicateContact) {
        return { disabled: true, message: "Il contatto è già presente tra quelli proposti: seleziona il contatto esistente.", duplicateContact };
      }
      if (shouldValidateContact && contatto.value.cod_comune && hasValue(contatto.value.cap)
        && !isContactCapValid(contatto.value.cap, contatto.value.cod_comune, opzioni.comuni)) {
        return { disabled: true, message: "Il CAP non è valido per il comune selezionato." };
      }

      // Se stiamo creando un NUOVO contatto o usando la sede cliente come contatto
      if (shouldValidateContact) {
        requiredField.push(
          { val: contatto.value.toponimo, label: 'Toponimo' },
          { val: contatto.value.indirizzo, label: 'Indirizzo' },
          { val: contatto.value.civico, label: 'Civico' },
          { val: contatto.value.cap, label: 'CAP' },
          { val: contatto.value.provincia, label: 'Provincia' },
          { val: contatto.value.cod_comune, label: 'Comune' },
          { val: contatto.value.email, label: 'Email' },
          { val: contatto.value.cellulare, label: 'Cellulare' }
        );
        if([1,3,4].includes(typeClient.value)) {
          if(!(canUsePecBypass.value && bypass_pec.value)) {
            requiredField.push({ val: contatto.value.pec, label: 'Pec' });
          }else{
            requiredField.push({ val: bypass_pec_reason.value, label: 'Motivazione del bypass della Pec' });
          }
        }
      }

      // --- 3. VERIFICA CAMPI MANCANTI ---
      const missing = requiredField.filter(f => !f.val || String(f.val).trim() === "");

      if (missing.length > 1) {
        return { disabled: true, message: "Inserisci tutti i campi obbligatori per il rappresentante." };
      } else if (missing.length === 1) {
        return { disabled: true, message: `Manca solo un campo: ${missing[0].label}` };
      }

      // --- 4. VALIDAZIONI FORMATO (Solo se i campi sono pieni) ---
      
      // Email e PEC
      const regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (contatto.value.email && !regex_email.test(contatto.value.email)) {
        return { disabled: true, message: "Formato email del contatto non valido." };
      }
      if ([1,3,4].includes(typeClient.value) && contatto.value.pec && !regex_email.test(contatto.value.pec)) {
        return { disabled: true, message: "Formato PEC del contatto non valido." };
      }
      if (repairSourceContactId.value && shouldValidateContact && !isValidMobile(contatto.value.cellulare)) {
        return { disabled: true, message: "Formato cellulare del contatto non valido." };
      }
      return res;
    });

    const addNewContact = () => {
      resetContactRepair()
      removeSameAddressContact()
      selectedContact.value = null
      sameAddress.value = false
      contatti.value.forEach(contact =>{
        contact.selected = false
      })
      contatto.value = {
        id: 0,
        prev_id: 0,
        toponimo: "",
        indirizzo: "",
        civico: "",
        cap: "",
        email: "",
        pec: null,
        tel: null,
        cell: "",
        cellulare: "",
        fax: null,
        cod_rapp: rappresentante.value.id,
        cod_comune: null,
        selected: false,
        name: "",
        provincia: ""
      }
      bypass_pec.value = false
      bypass_pec_reason.value = ''
      newContatto.value = true
    }

    const setNewContatto = () => {
      if (newContatto.value) {
        addNewContact()
      } else {
        setSelectedContact(contatti.value[0])
      }
    }

    return {
      loading,
      rappresentante,
      rappresentanteDetailUrl,
      activeTabIndex,
      format ,
      rappresentanti,
      submitted,
      isEmail,
      toponimi,
      districts,
      cities,
      canGoToStep3,
      canUseClientAddress,
      nextPage,
      prevPage,
      validationErrors,
      initRappresentante,
      onSelectedDistrict, 
      onSelectedCity,
      typeClient,
      onSelectedMobile,
      showModal,
      isCorrect,
      onSelected,
      status_percent_rapp,
      slides,
      contatto,
      newContatto,
      sameAddress,
      setSameAddress,
      addNewContact,
      contatti,
      selectedContact,
      repairSourceContactId,
      repairLockedFields,
      isRepairFieldLocked,
      contactCapSettings,
      contactCapSuffix,
      onContactCapSuffixInput,
      repairFormRef,
      needsContactCompletion,
      onSelectedContact,
      onSelectedToponimo,
      onSelectedView,
      type_insert,
      selectedTypeInsert,
      onSelectedTypeInsert,
      windowSize,
      onInputText,
      cf,
      inputCF,
      loaded_rappresentante,
      setNewContatto,
      forme_giuridiche,
      selectedFormaGiuridica,
      selectedFormaGiuridicaName,
      updateSelectedFormaGiuridica,
      bypass_pec,
      bypass_pec_reason,
      currentUser,
      isAdmin,
      canUsePecBypass,
      changeBypassPec,
      hasPecBypass,
      getPecBypassReason
    }
  },
}
</script>

<style>
.form-step .p-card-title, .form-step .p-card-subtitle {
    text-align: center;
}
</style>
<style scoped>

  .p-card{
    min-width: 335px !important;
  }
  .box-selected{
    position: relative;
    max-width: 60%;
    margin: 5px auto;
    border-radius: 20px;
    border: 1px solid rgb(105, 105, 105);
  }
  .btn-remove-selected {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
  }
  .selected-name {
    margin: 1rem 0 0.75rem;
    padding: 0 2.5rem;
    text-align: center;
  }
  .btn-detail-name {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.2rem;
  }
  .btn-detail-name:hover,
  .btn-detail-name:focus-visible {
    background-color: rgba(33, 81, 89, 0.1);
    color: #215159;
  }
  @media screen and (max-width: 767px) {
    .box-selected {
      max-width: 100%;
    }
  }
  .btn-contatto {
    width: 27%;
    min-height: 120px;
    height: auto;
    font-size: medium;
    overflow: hidden;
    justify-content: center;
  }
  .btn-contatto :deep(.p-button-label) {
    width: 100%;
  }
  .btn-contatto p {
    width: 100%;
    line-height: 1.35;
    white-space: normal;
    word-break: break-word;
  }
  .btn-contatto.btn-selection.duplicate-contact {
    position: relative;
    overflow: visible;
    z-index: 1;
    animation: duplicate-contact-pulse 1.3s ease-in-out infinite;
  }
  .duplicate-contact-badge {
    position: absolute;
    top: 50%;
    left: -2.6rem;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.2rem;
    height: 2.2rem;
    border-radius: 50%;
    background: transparent;
    color: #704c00;
    font-size: 1.5rem;
    line-height: 1;
    pointer-events: none;
  }
  @keyframes duplicate-contact-pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.06); }
  }
  @media (prefers-reduced-motion: reduce) {
    .btn-contatto.btn-selection.duplicate-contact {
      animation: none;
    }
  }
  .same-client-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin-bottom: 0.35rem;
    padding: 0.22rem 0.55rem;
    border-radius: 4px;
    border: 1px solid rgba(33, 81, 89, 0.25);
    background: #ffffff;
    color: #215159;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1;
  }
  .unselectable-contact-badge {
    display: inline-block;
    margin-bottom: 0.5rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    background: #fff2f2;
    color: #8b1f1f;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
  }
  .contact-data {
    line-height: 1.35;
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .invalid-contact-data {
    width: fit-content;
    max-width: 100%;
    margin: 0;
    padding: 0 0.4rem;
    background: #ffffff;
    color: #a11c1c;
    border-radius: 4px;
    font-weight: 700;
  }
  .contact-field-to-complete :deep(input.p-inputtext:not(:disabled)),
  .contact-field-to-complete :deep(textarea.p-inputtext:not(:disabled)),
  .contact-field-to-complete :deep(.p-dropdown:not(.p-disabled)) {
    background: #fff8e1;
    border: 2px solid #d99500;
    box-shadow: 0 0 0 2px rgba(217, 149, 0, 0.12);
  }
  .completion-note {
    margin-left: 0.3rem;
    color: #946600;
    font-weight: 700;
  }
  .contact-cap-prefix {
    min-width: 4rem;
    justify-content: center;
    background: #e9ecef;
    color: #495057;
    font-weight: 700;
    cursor: not-allowed;
    user-select: none;
  }
  :deep(input.p-inputtext:disabled),
  :deep(textarea.p-inputtext:disabled),
  :deep(.p-dropdown.p-disabled) {
    opacity: 0.6;
    pointer-events: auto;
    cursor: not-allowed;
    background: #f5f5f5;
    color: #6c757d;
  }
  :deep(.p-dropdown.p-disabled .p-dropdown-label),
  :deep(.p-dropdown.p-disabled .p-dropdown-trigger) {
    color: #6c757d;
  }
  :deep(.p-dropdown.p-disabled),
  :deep(.p-dropdown.p-disabled *) {
    cursor: not-allowed !important;
  }
  .contact-repair-form :deep(.p-dropdown .p-inputtext) {
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .btn-selection {
    border-radius: 20px;
    opacity: 0.5;
    /* 1. Aggiungi transform alla transition */
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    /* 2. Imposta la scala ridotta di base */
    transform: scale(0.8); 
  }
  .btn-selection:hover,.btn-reset:hover {
    background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
    opacity: 1;
  }
  .btn-selection.selected {
    opacity: 1;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    /* 4. Riporta alla dimensione piena (o più grande) quando selezionato */
    transform: scale(0.9); 
  }
  @media screen and (max-width: 1400px) {
    .btn-contatto {
      width: 36%;
      min-height: 120px;
      height: 120px;
      font-size: small;
    }
  }

  @media screen and (max-width: 767px) {
    .btn-contatto {
      width: 100%;
      min-height: 120px;
      height: 120px;
      font-size: 0.95rem;
    }
    .btn-contatto p {
      font-size: 0.95rem;
      line-height: 1.45;
    }
    .same-client-badge {
      font-size: 0.8rem;
    }
  }

  .btn-contatto.btn-selection {
    text-align: left;
    font-size: 1.15rem;
    font-weight: 400;
    opacity: 1;
  }
  .btn-contatto.btn-selection:not(.selected),
  .btn-contatto.btn-selection:not(.selected):hover {
    background: #8ebac1;
  }
  .btn-contatto.btn-selection.selected {
    background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
  }
  .btn-contatto :deep(.p-button-label) {
    text-align: left;
    font-weight: 400;
  }
  .btn-contatto p {
    font-size: inherit;
  }
  .contact-label {
    font-weight: 700;
    margin-right: 0.2rem;
  }
</style>
